import "./MarketingConsentCheckbox.css";

// Optional email marketing opt-in. Must stay unticked by default (Brevo / privacy law).
const MarketingConsentCheckbox = ({ checked, onChange, id = "marketingConsent", className = "" }) => {
	return (
		<label htmlFor={id} className={`marketing-consent ${checked ? "is-checked" : ""} ${className}`}>
			<input
				type="checkbox"
				id={id}
				checked={!!checked}
				onChange={(e) => onChange(e.target.checked)}
			/>
			<span className="marketing-consent-body">
				<span className="marketing-consent-title">🎁 Get members-only diamond deals</span>
				<span className="marketing-consent-text">
					Be the first to know about price drops, new game packs and special offers by email. No spam, unsubscribe anytime.
				</span>
			</span>
		</label>
	);
};

export default MarketingConsentCheckbox;
